import Link from 'next/link';
import YearNavigation from '../YearNavigation';
import WorkWeekToggle from '../WorkWeekToggle';

type YearlyHeaderProps = {
  year: number;
  workWeek: 'five' | 'six';
  setWorkWeek: React.Dispatch<React.SetStateAction<'five' | 'six'>>;
  periods?: { start: string; end: string }[];
  holidayDates?: Map<string, string>;
  basePath?: string;
};

function findHolidayInPeriod(start: string, end: string, holidayDates?: Map<string, string>) {
  if (!holidayDates) return null;
  const s = new Date(start);
  const e = new Date(end);
  const cur = new Date(s);
  while (cur <= e) {
    const yyyy = cur.getFullYear();
    const mm = String(cur.getMonth() + 1).padStart(2, '0');
    const dd = String(cur.getDate()).padStart(2, '0');
    const key = `${yyyy}-${mm}-${dd}`;
    if (holidayDates.has(key)) return key;
    cur.setDate(cur.getDate() + 1);
  }
  return null;
}

export function YearlyHeader({ year, workWeek, setWorkWeek, periods = [], holidayDates, basePath = '' }: YearlyHeaderProps) {
  return (
    <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between mt-2 gap-2 sm:gap-0">
      <div className="flex-1 hidden sm:flex items-center">
        {(() => {
          let href = `${basePath}atostogu-prasymas`;
          if (periods.length > 0) {
            // compute the earliest start and latest end from selected periods
            let minStart: string | null = null;
            let maxEnd: string | null = null;
            for (const p of periods) {
              if (!p.start || !p.end) continue;
              if (!minStart || p.start < minStart) minStart = p.start;
              if (!maxEnd || p.end > maxEnd) maxEnd = p.end;
            }

            if (minStart && maxEnd) {
              const qs = `?start=${encodeURIComponent(minStart)}&end=${encodeURIComponent(maxEnd)}`;
              href = `${basePath}atostogu-prasymas${qs}`;
            }
          }

          return (
              <Link
                href={href}
                className="inline-flex items-center px-3 py-2 bg-[#0d47a1] text-white font-semibold rounded shadow hover:bg-[#0b3b88] focus:outline-none focus:ring-2 focus:ring-blue-400"
                aria-label="Atostogų prašymas"
              >
              Atostogų prašymas
            </Link>
          );
        })()}
      </div>

      <div className="flex-1 flex justify-center order-1 sm:order-none w-full sm:w-auto">
        <YearNavigation year={year} setYearValue={() => {}} basePath={basePath} />
      </div>

      <div className="flex-1 flex justify-center sm:justify-end relative z-50 order-2 sm:order-none w-full sm:w-auto">
        <WorkWeekToggle workWeek={workWeek} setWorkWeek={setWorkWeek} />
      </div>
    </div>
  );
}
